import { authSlice } from './auth/slices';
import { dealerSlice } from './dealers/slices';
import { globalConfigurationsSlice } from './globalConfigurations/slices';
import { systemDownSlice } from './systemDown/slices';

export const reducers = {
  auth: authSlice.reducer,
  dealers: dealerSlice.reducer,
  globalConfigurations: globalConfigurationsSlice.reducer,
  systemDown: systemDownSlice.reducer,
};
